<template>
  <app-dialog v-bind="$attrs" persistent @input="$emit('input', $event)">
    <template #title>
      <slot name="title"> Create </slot>
    </template>
    <template #activator="{ on }">
      <slot name="activator" :on="on" />
    </template>
    <slot />
    <v-divider />
    <v-card-actions>
      <app-confirm-buttons
        :loading="loading"
        :next="next"
        :prev="prev"
        @cancel="$emit('reject')"
        @success="$emit('success')"
      >
        <template #accept>{{ acceptText || "Accept" }}</template>
        <template #cancel>{{ cancelText || "Cancel" }}</template>
      </app-confirm-buttons>
    </v-card-actions>
  </app-dialog>
</template>
<script lang="ts">
import Vue from "vue";
import ConfirmButtons from "@/components/ConfirmButtons.vue";
import Dialog from "./Dialog.vue";

export default Vue.extend({
  components: {
    appConfirmButtons: ConfirmButtons,
    appDialog: Dialog,
  },
  props: {
    loading: Boolean,
    prev: {
      required: false,
      default: true,
      type: Boolean,
    },
    next: {
      required: false,
      default: true,
      type: Boolean,
    },
    acceptText: String,
    cancelText: String,
  },
});
</script>
